import {
  LISTA_CONTAS_PAGAR,
  LISTA_CONTAS_PAGAR_SUCCESSFUL,
  CATEGORIAS_CONTA_PAGAR,
  CATEGORIAS_CONTA_PAGAR_SUCCESSFUL,
  CAIXAS_CONTA_PAGAR,
  CAIXAS_CONTA_PAGAR_SUCCESSFUL,
  CENTROCUSTO_CONTA_PAGAR,
  CENTROCUSTO_CONTA_PAGAR_SUCCESSFUL,
  PACIENTES_CONTA_PAGAR,
  PACIENTES_CONTA_PAGAR_SUCCESSFUL,
  CADASTRAR_CONTA_PAGAR,
  CADASTRAR_CONTA_PAGAR_SUCCESSFUL,
  EDITAR_CONTA_PAGAR,
  EDITAR_CONTA_PAGAR_SUCCESSFUL,
  VIEW_CONTA_PAGAR,
  VIEW_CONTA_PAGAR_SUCCESSFUL,
} from './actionTypes';

const INIT_STATE = {
  error: '',
  contas: {
    data: {
      result: [],
      pagination: {
        start: 0,
        end: 0,
        total: 0,
      },
    },
    isLoading: true,
  },
  categorias: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  caixas: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  centrocusto: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  pacientes: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  contapagar: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  isSave: false,
};

const Expenditure = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_CONTAS_PAGAR:
      return {
        ...state,
        contas: {
          data: {
            result: [],
            pagination: {
              start: 0,
              end: 0,
              total: 0,
            },
          },
          isLoading: true,
        },
      };
    case LISTA_CONTAS_PAGAR_SUCCESSFUL:
      return {
        ...state,
        contas: {
          data: {
            result: action.payload.result,
            pagination: action.payload.pagination,
          },
          isLoading: false,
        },
      };
    case CATEGORIAS_CONTA_PAGAR:
      return {
        ...state,
        categorias: {
          data: {
            result: [],
          },
          isLoading: true,
        },
        isSave: false,
      };
    case CATEGORIAS_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        categorias: {
          data: { result: action.payload.result },
          isLoading: false,
        },
      };
    case CAIXAS_CONTA_PAGAR:
      return {
        ...state,
        caixas: {
          data: {
            result: [],
          },
          isLoading: true,
        },
      };
    case CAIXAS_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        caixas: {
          data: { result: action.payload.result },
          isLoading: false,
        },
      };
    case CENTROCUSTO_CONTA_PAGAR:
      return {
        ...state,
        centrocusto: {
          data: {
            result: [],
          },
          isLoading: true,
        },
      };
    case CENTROCUSTO_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        centrocusto: {
          data: { result: action.payload.result },
          isLoading: false,
        },
      };
    case PACIENTES_CONTA_PAGAR:
      return {
        ...state,
        pacientes: {
          data: {
            result: [],
          },
          isLoading: true,
        },
      };
    case PACIENTES_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        pacientes: {
          data: { result: action.payload.result },
          isLoading: false,
        },
      };
    case CADASTRAR_CONTA_PAGAR:
      return {
        ...state,
        isSave: false,
      };
    case CADASTRAR_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        isSave: true,
      };
    case EDITAR_CONTA_PAGAR:
      return {
        ...state,
        isSave: false,
      };
    case EDITAR_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        isSave: true,
      };
    case VIEW_CONTA_PAGAR:
      return {
        ...state,
        contapagar: {
          data: {
            result: [],
          },
          isLoading: true,
        },
      };
    case VIEW_CONTA_PAGAR_SUCCESSFUL:
      return {
        ...state,
        contapagar: {
          data: { result: action.payload },
          isLoading: false,
        },
      };
    default:
      return { ...state };
  }
};

export default Expenditure;
